/**
 * @name $analyticsProvider
 * @desc Common routine which manages User event capture for Web Analytics for the iFastWeb Plus application
 */
(function (angular) {
    "use strict";

    var ACCT = "acct",
        ACCOUNT = "account",
        ADVISOR = "advisor",
        BUTTON = "Button",
        CONFIRMATION = "Confirmation",
        NAVIGATION = "Navigation",
        PAGINATION = "Pagination",
        FUND = "fund",
        EXPAND = "Expand",
        INFOICON = "Info Icon",
        LOGIN = "Login",
        FORGOTUID = "ForgotUID",
        FORGOTPWD = "ForgotPwd",
        USERSELFREG = "UserSelfRegister",
        CHANGEPWD = "ChangePassword",
        RESETPWD = "ResetPassword",
        ADDSALESREP = "AddSalesRep",
        PDF = "PDF",
        CLOSE = "Close",
        XLS ="XLS",
        COLLAPSE = "Collapse",
        SHOW = "Show",
        COMPACT = "Compact",
        BRANCHCODE = "branchCode",
        BROKERCODE = "brokerCode",
        SLSREPCODE = "slsRepCode",
        BRANCH = "branch",
        BROKER = "broker",
        SLSREP = "rep",
        SEARCH = "Search",
        FILTER = "Filter",
        GENERAL = "general",
        LINK = "Link",
        LOAD = "Load",
        SORT = "Sort",
        CANCEL = "Cancel",
        ERROR = "Error",
        INPUT = "Input",
        DROPDOWN = "Dropdown",
        REMOVESALESREP ="RemoveSalesRep",
        STARRED = "Starred",
        UNSTARRED = "Unstarred",
        STATEMENT_SLIPS_PDF = "Statement Slips PDF",
        GENERAL_INFO_ICON = "General Info Icon";

    /**
     * Retrieve utc number datetime.
     * @returns {number}
     */
    function getUTCTime() {
        return new Date().getTime();
    }

    /**
     * Retrieve the current url route path name. (ex. account, advisor, fund)
     * @returns {*}
     */
    function getRoutePathName() {
        return /#!\/([a-zA-Z]+)\/?/.exec(window.location.href)[1];
    }

    /**
     * Retrieve current area from browser url and determine if main area otherwise it is 'general'
     * (highest level)
     * @returns {*}
     */
    function getMainArea(action, properties, selectedContext, userid) {
        var moduleSpecificMainArea = getModuleSpecificMainArea(properties);

        if(moduleSpecificMainArea) {
            return moduleSpecificMainArea;
        } else if(angular.isDefined(selectedContext)) {
            return getSelectedContextMainArea(selectedContext, userid);
        } else {
            return getRoutePathName();
        }
    }

    var mainAreaMap = {
        "account" : "AcctSRCH",
        "advisor" : "AdvrSRCH",
        "fund" : "FundContext"
    };

    /**
     * Given a path name determine if it account, advisor, fund or general .
     * @param name
     * @returns {String}
     */
    function getMainAreaName(name){
        return (mainAreaMap[name])? mainAreaMap[name]: GENERAL;
    }

    function getModuleSpecificMainArea(properties) {
        var mainArea;

        switch(properties.module){
            case "TermsAndConditions":
            case "ClientSetting":
            case "UserSelfRegistrationSetting":
            case "ContactUs":
            case "companyLink":
            case "logouts":
            case "Logins":
            case "Prelogin":
            case "system":
                mainArea = "general";
                break;
        }

        return mainArea;
    }

    /**
     * Determine the selected context main area. (lowest level inside selected Context attribute)
     * @param selectedContext
     * @param userId
     * @returns {string}
     */
    function getSelectedContextMainArea(selectedContext, userId) {
        return (userId === null) ? GENERAL : getMainAreaName( getAreaFromContext(selectedContext));
    }

    /**
     * A helper function that returns the value of properties or null
     * @param properties
     * @param field
     * @returns {*}
     */
    function getAttributeValue(properties, field) {
        if (properties && typeof properties[field] !== "undefined") {
            return properties[field];
        }
        return null;
    }

    /**
     * Determine the selected context area.
     * @param selectedContext
     * @returns {string}
     */
    function getAreaFromContext(selectedContext) {
        if (getAttributeValue(selectedContext, ACCT) === null) {
            if ((getAttributeValue(selectedContext, BRANCHCODE) || getAttributeValue(selectedContext, BRANCH)) === null ||
                (getAttributeValue(selectedContext, BROKERCODE) || getAttributeValue(selectedContext, BROKER)) === null ||
                (getAttributeValue(selectedContext, SLSREPCODE) || getAttributeValue(selectedContext, SLSREP))=== null) {
                return FUND;
            } else {
                return ADVISOR;
            }
        } else {
            return ACCOUNT;
        }
    }

    /**
     * Build the payload attributes based on the action type.
     * @param action
     * @param properties
     * @returns {{}}
     */
    function buildAttribute(action, properties) {
        var requestParam = {};
        switch (action) {
            case STARRED:
            case UNSTARRED:
            case SEARCH:
                var acct = getAttributeValue(properties, ACCT);
                requestParam = {
                    search: {
                        acct: acct,
                        rep: (acct === null) ? getAttributeValue(properties, SLSREPCODE) : null,
                        branch: (acct === null) ? getAttributeValue(properties, BRANCHCODE) : null,
                        broker: (acct === null) ? getAttributeValue(properties, BROKERCODE) : null
                    }
                };
                break;
            case SORT:
                requestParam = {
                    sort: {
                        value: getAttributeValue(properties, "value"),
                        text: getAttributeValue(properties, "text"),
                        dir: getAttributeValue(properties[0], "dir"),
                        objectName: getAttributeValue(properties, "submodule"),
                        fieldName: getAttributeValue(properties[0], "field")
                    }
                };
                break;
            case LINK:
                /* link: {text:"contact us",value:"contact us",fieldName:"contactUs"}  */
                requestParam = {
                    link: {
                        value: getAttributeValue(properties, "value"),
                        text: getAttributeValue(properties, "text"),
                        fieldName: getAttributeValue(properties, "fieldName"),
                        objectName: getAttributeValue(properties, "objectName")
                    }
                };
                break;
            case CONFIRMATION:
            case BUTTON:
                requestParam = {
                    button: {
                        value: getAttributeValue(properties, "value"),
                        text: getAttributeValue(properties, "text"),
                        fieldName: getAttributeValue(properties, "fieldName"),
                        objectName: getAttributeValue(properties, "objectName")
                    }
                };
                break;
            case NAVIGATION:
                requestParam = {
                    navigation: {
                        value: getAttributeValue(properties, "value"),
                        text: getAttributeValue(properties, "text"),
                        fieldName: getAttributeValue(properties, "fieldName"),
                        objectName: getAttributeValue(properties, "objectName")
                    }
                };
                break;
            case PAGINATION:
            case EXPAND:
            case COMPACT:
            case SHOW:
            case COLLAPSE:
            case INFOICON:
            case PDF:
            case XLS:
            case CLOSE:
            case CANCEL:
                break;
            case LOGIN:
                requestParam = {
                    username: {
                        value: getAttributeValue(properties, "usernameValue"),
                        text: getAttributeValue(properties, "usernameText"),
                        fieldName: getAttributeValue(properties, "usernameFieldName"),
                        objectName: getAttributeValue(properties, "usernameObjectName")
                    }
                };
                break;
            case FORGOTUID:
                requestParam = {
                    email: {
                        value: getAttributeValue(properties, "emailValue"),
                        text: getAttributeValue(properties, "emailText"),
                        fieldName: getAttributeValue(properties, "emailFieldName"),
                        objectName: getAttributeValue(properties, "emailObjectName")
                    }
                };
                break;
            case FORGOTPWD:
                requestParam = {
                    email: {
                        value: getAttributeValue(properties, "emailValue"),
                        text: getAttributeValue(properties, "emailText"),
                        fieldName: getAttributeValue(properties, "emailFieldName"),
                        objectName: getAttributeValue(properties, "emailObjectName")
                    }
                };
                break;
            case USERSELFREG:
                requestParam = {
                    fullname: {
                        value: getAttributeValue(properties, "fullnameValue"),
                        text: getAttributeValue(properties, "fullnameText"),
                        fieldName: getAttributeValue(properties, "fullnameFieldName"),
                        objectName: getAttributeValue(properties, "fullnameObjectName")
                    },
                    phone: {
                        value: getAttributeValue(properties, "phoneValue"),
                        text: getAttributeValue(properties, "phoneText"),
                        fieldName: getAttributeValue(properties, "phoneFieldName"),
                        objectName: getAttributeValue(properties, "phoneObjectName")
                    },
                    dealerOrBrokerCode: {
                        value: getAttributeValue(properties, "dealerOrBrokerCodeValue"),
                        text: getAttributeValue(properties, "dealerOrBrokerCodeText"),
                        fieldName: getAttributeValue(properties, "dealerOrBrokerCodeFieldName"),
                        objectName: getAttributeValue(properties, "dealerOrBrokerCodeObjectName")
                    },
                    repCode: {
                        value: getAttributeValue(properties, "repCodeValue"),
                        text: getAttributeValue(properties, "repCodeText"),
                        fieldName: getAttributeValue(properties, "repCodeFieldName"),
                        objectName: getAttributeValue(properties, "repCodeObjectName")
                    },
                    userName: {
                        value: getAttributeValue(properties, "userNameValue"),
                        text: getAttributeValue(properties, "userNameText"),
                        fieldName: getAttributeValue(properties, "userNameFieldName"),
                        objectName: getAttributeValue(properties, "userNameObjectName")
                    },
                    email: {
                        value: getAttributeValue(properties, "emailValue"),
                        text: getAttributeValue(properties, "emailText"),
                        fieldName: getAttributeValue(properties, "emailFieldName"),
                        objectName: getAttributeValue(properties, "emailObjectName")
                    },
                    comments: {
                        value: getAttributeValue(properties, "commentsValue"),
                        text: getAttributeValue(properties, "commentsText"),
                        fieldName: getAttributeValue(properties, "commentsFieldName"),
                        objectName: getAttributeValue(properties, "commentsObjectName")
                    }

                };
                break;
            case CHANGEPWD:
                requestParam = {
                    username: {
                        value: getAttributeValue(properties, "usernameValue"),
                        text: getAttributeValue(properties, "usernameText"),
                        fieldName: getAttributeValue(properties, "usernameFieldName"),
                        objectName: getAttributeValue(properties, "usernameObjectName")
                    }
                };
                break;
            case RESETPWD:
                requestParam = {
                    username: {
                        value: getAttributeValue(properties, "value"),
                        text: getAttributeValue(properties, "text"),
                        fieldName: getAttributeValue(properties, "fieldName"),
                        objectName: getAttributeValue(properties, "objectName")
                    }
                };
                break;
            case ADDSALESREP:
                requestParam = {
                    repCodes: {
                        value: getAttributeValue(properties, "repValue"),
                        text: getAttributeValue(properties, "repText"),
                        fieldName: getAttributeValue(properties, "repFieldName"),
                        objectName: getAttributeValue(properties, "repObjectName")
                    },
                    comment: {
                        value: getAttributeValue(properties, "commentValue"),
                        text: getAttributeValue(properties, "commentText"),
                        fieldName: getAttributeValue(properties, "commentFieldName"),
                        objectName: getAttributeValue(properties, "commentObjectName")
                    }
                };
                break;
            case REMOVESALESREP:
                break;
            case GENERAL_INFO_ICON:
                requestParam = {
                    content: {
                        value: getAttributeValue(properties, "value"),
                        text: getAttributeValue(properties, "text"),
                        fieldName: getAttributeValue(properties, "fieldName"),
                        objectName: getAttributeValue(properties, "objectName")
                    }
                };
                break;
            case ERROR:
                requestParam = {
                    error: {
                        value: getAttributeValue(properties, "value"),
                        text: getAttributeValue(properties, "text"),
                        fieldName: getAttributeValue(properties, "fieldName"),
                        objectName: getAttributeValue(properties, "objectName")
                    }
                };
                break;
            case INPUT:
            case DROPDOWN:
            case FILTER:
                break;
            case LOAD:
                if (properties.loadAnalyticsFilter) {
                    requestParam = properties.loadAnalyticsFilter();
                }
                break;
            case STATEMENT_SLIPS_PDF:
                requestParam = {
                    link: {
                        value: getAttributeValue(properties, "value"),
                        text: getAttributeValue(properties, "text"),
                        fieldName: getAttributeValue(properties, "fieldName"),
                        objectName: getAttributeValue(properties, "objectName")
                    },
                    doctype: {
                        value: getAttributeValue(properties, "doctypeValue"),
                        text: getAttributeValue(properties, "doctypeText"),
                        fieldName: getAttributeValue(properties, "doctypeFieldName"),
                        objectName: getAttributeValue(properties, "doctypeObjectName")
                    },
                    source: {
                        value: getAttributeValue(properties, "sourceValue"),
                        text: getAttributeValue(properties, "sourceText"),
                        fieldName: getAttributeValue(properties, "sourceFieldName"),
                        objectName: getAttributeValue(properties, "sourceObjectName")
                    }
                };
                break;
            default:
                break;
        }
        //Load dynamic attributes into filters.
        if (properties.replaceAttributes && typeof properties.getAnalyticsFilter === "function") {
            requestParam = properties.getAnalyticsFilter();
        } else if (typeof properties.getAnalyticsFilter === "function"){
            requestParam = angular.extend(requestParam, properties.getAnalyticsFilter());
        }
        return requestParam;
    }

    /**
     * Configuration function supplied to analyticsProvider.
     * @param $analyticsProvider
     * @param $locationProvider
     */
    var analyticsConfig = function ($analyticsProvider) {

        // Set the default settings for this module
        $analyticsProvider.settings.ifast = {
            userInfo: {},
            selectedContext: undefined
        };

        // Set the userInfo properties in analytics settings
        $analyticsProvider.registerSetUserProperties(function (userProperties) {
            $analyticsProvider.settings.ifast.userInfo = userProperties;
        });

        // Set the Selected context object is analytics settings.
        $analyticsProvider.settings.setSelectedContext = function (selectedContext) {
            var acct = getAttributeValue(selectedContext, "acct");
            $analyticsProvider.settings.ifast.selectedContext = {
                "main_area": getSelectedContextMainArea(selectedContext, $analyticsProvider.settings.ifast.userInfo.qualifieduserid),
                "acct": acct,
                "branch": (acct === null) ? getAttributeValue(selectedContext, BRANCHCODE) : null,
                "broker": (acct === null) ? getAttributeValue(selectedContext, BROKERCODE) : null,
                "rep": (acct === null) ? getAttributeValue(selectedContext, SLSREPCODE) : null
            };
        };


        $analyticsProvider.registerEventTrack(function (action, properties) {
            var attributes, requestParam, ajaxCallConfig;

            attributes = buildAttribute(action, properties);

            requestParam = {
                "browser_ts": getUTCTime(),
                "sessionid": $analyticsProvider.settings.ifast.userInfo.sessionid,
                "companyid": $analyticsProvider.settings.ifast.userInfo.clientCd,
                "slotname": $analyticsProvider.settings.ifast.userInfo.slotname,
                "userid": $analyticsProvider.settings.ifast.userInfo.qualifiedUserId,
                "language": $analyticsProvider.settings.ifast.userInfo.language,
                "main_area": getMainArea(action, properties, $analyticsProvider.settings.ifast.selectedContext, $analyticsProvider.settings.ifast.userInfo.qualifiedUserId),
                "module": properties.module,
                "submodule": properties.submodule,
                "act_type": action,
                "user_agent": navigator.userAgent,
                "selectedContext": $analyticsProvider.settings.ifast.selectedContext,
                "attributes": attributes
            };


            var restSrvcContextRoot = "";

            ajaxCallConfig = {
                url: restSrvcContextRoot + "rest/json/dynamicreporting/loggingservice",
                method: "POST",
                data: JSON.stringify(requestParam),
                dataType: "json",
                contentType: "application/json"
            };

            window.console.log("Angulartic >> action:", "\"" + action + "\"", "attributes:", properties);

            $.ajax(ajaxCallConfig);
        });
    };

    angular.module("iFAST.angulartics", ["angulartics"])
        .config(["$analyticsProvider", "$locationProvider", analyticsConfig]);
})(angular);



// WEBPACK FOOTER //
// ./WebContent/src/_common/services/shared/angulartics-webreporting.js